import endpoint from "../../config/endpoints";

export const ProductRateFooterJson = {
  showSaveNextBtn: false,
  apiBaseURL: endpoint.room,
  formPath: "",
  screenTitle: "",
  showTitle: false,
  showCancel: false,
  showSaveBtn: false,
  fieldMeta: [
    {
      label: "Publish Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "publishDate",
      isMandatory: true,
    },
  ],
};
